import React from "react";

import Link from "gatsby-link";

export default class Header extends React.Component {
  handleClick(event) {
    if (event.target.tagName.toLowerCase() === "a") event.target.blur();
  }

  render() {
    return (
      <header onClick={this.handleClick}>
        <Link to="/">
          <h1>Sign Awning</h1>
          <p>Fully Licensed Specialists</p>
        </Link>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header.js